import { render, staticRenderFns } from "./StartDate.vue?vue&type=template&id=45576356&scoped=true&"
import script from "./StartDate.vue?vue&type=script&lang=ts&"
export * from "./StartDate.vue?vue&type=script&lang=ts&"
import style0 from "./StartDate.vue?vue&type=style&index=0&id=45576356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45576356",
  null
  
)

export default component.exports